/*global openFB */
export const fbCheckStatus = (methodType, activity) => {
  if (typeof (openFB) !== undefined && openFB !== null) {
    openFB.getLoginStatus(
      (response) => {
        console.log("getlogin status response", response);
        statusChangeCallback(response, methodType, activity);
      }
    )
  } else {
    console.log("FB is not available yet");
  }
}

const statusChangeCallback = (response, methodType, activity) => {
  if (response.status === 'connected') {
    console.log('connected');
    if (methodType === "post") {
      //postOnFB(response);
      DoAPICalls(response);
      console.log("done post");
    } else {
      DoAPICalls(response);
      console.log("no post");
    }
  } else if (response.status === 'not_authorized') {
    console.log("not_authorized");
    openFB.login(
      (response) => {
        if (response.authResponse) {
          console.log("welcome to facebook");
          DoAPICalls(response);
        } else {
          console.log("cancelled login");
        }
      },
      { scope: 'public_profile,user_birthday,user_gender' }
    )
  } else {
    console.log("use is loged out of both accounts");
    openFB.login(
      (response) => {
        if (response.authResponse) {
          console.log("welcome to facebook");
          DoAPICalls(response);
        } else {
          console.log("cancelled login");
        }
      },
      { scope: 'public_profile,user_birthday,user_gender' }
    )
  }
}

const removeCookies = () => {
  console.log("remove cookies");
  let cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    let eqPos = cookie.indexOf("=");
    let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
export const logoutM = () => {
  let FBUserInfo = localStorage.getItem("FB_user_info");
  if (FBUserInfo && FBUserInfo !== "null") {
    localStorage.setItem("FB_user_info", null);
    localStorage.setItem("user_profile", null);
    try {
      if (typeof (openFB) !== undefined && openFB !== null) {
        openFB.getLoginStatus(
          (response) => {
            if (response.status === 'connected') {
              console.log("it is connected")
              openFB.logout((res) => {
                console.log("logout", res);
                //alert("logged out.");
                removeCookies();
                document.location.reload();
              });
            }
          }
        )
      }
    } catch (e) {
      console.log("error while logging out");
    }
  }
}

const DoAPICalls = (response) => {
  let checkForNewSession = sessionStorage.getItem("NewSession");
  let FBUserInfo = localStorage.getItem("FB_user_info");
  let profilePic = localStorage.getItem("user_profile");
  if (!FBUserInfo || FBUserInfo === "null") {
    openFB.api({
      path: `/me/`,
      method: 'GET',
      params: { "fields": "first_name,name,birthday,gender,age_range" },
      success: (response) => {
        if (response) {
          //alert("api response", response);
          response = JSON.stringify(response);
          localStorage.setItem("FB_user_info", response);
          console.log("api response", response);
        }
      },
      error: () => { console.log("error while making fb api call") }
    });
  } else {
    console.log("FBUserInfo", FBUserInfo);
  }

  if (!checkForNewSession || !profilePic || profilePic === "null") {
    sessionStorage.setItem("NewSession", true);
    console.log("checkForNewSession", checkForNewSession, profilePic)
    openFB.api({
      path: `/me/picture`,
      method: 'GET',
      params: {
        "redirect": false,
        "height": "200",
        "type": "normal",
        "width": "200"
      },
      success: (response) => {
        if (response) {
          localStorage.setItem("user_profile", response.data.url);
          console.log("picture", response.data.url);
        }
      },
      error: () => {
        console.log("error while making fb api call")
      }
    });
  } else {
    console.log("we have a picture no need to fetch from facebook", profilePic);

  }
}
/*
const DoAPICalls = (response) => {
  console.log("DoAPICalls method called");
  let checkForNewSession = sessionStorage.getItem("NewSession");
  let FBUserInfo = localStorage.getItem("FB_user_info");
  if (!FBUserInfo) {
    openFB.api({
      path: `/me/`,
      method: 'GET',
      params: { "fields": "name,birthday,gender,age_range" },
      success: (response) => {
        if (response) {
          //alert("api response", response);
          response = JSON.stringify(response);
          localStorage.setItem("FB_user_info", response);
          console.log("api response", response);
        }
      },
      error: () => { console.log("error while making fb api call") }
    });
  } else {
    console.log("FBUserInfo", FBUserInfo)
  }

  if (!checkForNewSession) {
    console.log("checkForNewSession is false");
    sessionStorage.setItem("NewSession", true);
    openFB.api({
      path: `/me/picture`,
      method: 'GET',
      params: {
        "redirect": false,
        "height": "200",
        "type": "normal",
        "width": "200"
      },
      success: (response) => {
        if (response) {
          localStorage.setItem("user_profile", response.data.url);
          console.log("picture", response.data.url);
        }
      },
      error: () => {
        console.log("error while making fb api call")
      }
    });
  } else {
    console.log('NO NEED TO UPDATE image, url=');
  }
}
*/
/* FB.api(
`/${response.authResponse.userID}/music`,
function (response) {
if (response && !response.error) {
console.log("music",response)
}
}
);*/

const postOnFB = (response) => {
  /*
  FB.ui({
  method: 'feed',
  link: 'https://www.w3schools.com/jsref/tryit.asp?filename=tryjsref_indexof'
  }, (response) => {
  console.log("post on facebook", response)
  });
  */
}